export default __webpack_public_path__ + "static/img/bottedbg.e21d2bf.png";